import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { backend_url } from '../config/url.config'

@Injectable({
    providedIn: 'root'
})
export class PolygonService {
    readonly URL_API_COUNTRY_REGION = backend_url + '/api/regions/';
    readonly URL_API_ONE_URBAN_AREAS = backend_url + '/api/regions/region/';
    readonly URL_API_URBAN_AREAS = backend_url + '/api/metropolitanAreas/';
    readonly URL_API_URBAN_AREAS_EXPOSITION = backend_url + '/api/regions/municipalityExposure/';
    readonly URL_API_URBAN_AREAS_ALL_EXPOSITION = backend_url + '/api/regions/AllregionsmunicipalityExposure/';
    readonly URL_API_METROPOLITAN = backend_url + '/api/metropolitanAreas/area/';
    readonly URL_API_METROPOLITAN_EXPOSITION = backend_url + '/api/metropolitanAreas/municipalityExposure/';
    readonly URL_API_MUNICIPALITIES = backend_url + '/api/localities/';
    readonly URL_API_STATES = backend_url + '/api/municipalities/';
    readonly URL_API_STATES_EXPOSITION = backend_url + '/api/states/municipalityExposure/';
    readonly URL_API_COUNTRY = backend_url + '/api/states/';
    readonly URL_API_COUNTRY_EXPOSITION = backend_url + '/api/states/municipalityExposure/mexico';
    readonly URL_API_LOCALITIES = backend_url + '/api/localities/locality';
    readonly URL_API_AGEB = backend_url + '/api/agebs/ageb';
    readonly URL_API_CASES_COUNTRY = backend_url + '/api/cases/';
    readonly URL_API_CASES_STATE = backend_url + '/api/cases/state';

    constructor(private http: HttpClient) { }

    getCountryRegion(){
        return this.http.post(this.URL_API_COUNTRY_REGION, {
            "token": "o:-t3zTt0q3n-:o"
        });
    }

    getUrbanAreas() {
        return this.http.post(this.URL_API_URBAN_AREAS, {
            "token": "o:-t3zTt0q3n-:o"
        });
    }

    getOneUrbanAreas(region) {
        return this.http.post(this.URL_API_ONE_URBAN_AREAS, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_reg": region
        });
    }

    getMetropolitan(metropolitan, mode="") {
        return this.http.post(this.URL_API_METROPOLITAN, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_sun": metropolitan,
            "mode": mode
        });
    }

    getCountry() {
        return this.http.post(this.URL_API_COUNTRY, {
            "token": "o:-t3zTt0q3n-:o"
        });
    }

    getStates(municipality) {
        return this.http.post(this.URL_API_STATES, {
            "token": "o:-t3zTt0q3n-:o",
            "entidad_cvegeo": municipality
        });
    }

    getMunicipalities(locality, mode="") {
        return this.http.post(this.URL_API_MUNICIPALITIES, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_mun": locality,
            "mode": mode
        });
    }

    getLocalities(locality,mode="") {
        return this.http.post(this.URL_API_LOCALITIES, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_loc": locality,
            "mode": mode
        });
    }

    getAgeb(ageb,mode="") {
        return this.http.post(this.URL_API_AGEB, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_ageb": ageb,
            "mode": mode
        });
    }

    getCountryCases(){
        return this.http.post(this.URL_API_CASES_COUNTRY, {
            "token": "o:-t3zTt0q3n-:o"
        });
    }

    getStateCases(name){
        return this.http.post(this.URL_API_CASES_STATE, {
            "token": "o:-t3zTt0q3n-:o",
            "name": name
        });
    }

    getStateExposition(name){
        return this.http.post(this.URL_API_METROPOLITAN_EXPOSITION, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_sun": name
        });
    }

    getStatesExpositionModoNormal(municipality) {
        return this.http.post(this.URL_API_STATES_EXPOSITION, {
            "token": "o:-t3zTt0q3n-:o",
            "entidad_cvegeo": municipality
        });
    }

    getOneUrbanAreasExposition(region) {
        return this.http.post(this.URL_API_URBAN_AREAS_EXPOSITION, {
            "token": "o:-t3zTt0q3n-:o",
            "cve_reg": region
        });
    }

    getAllUrbanAreasExposition() {
        return this.http.post(this.URL_API_URBAN_AREAS_ALL_EXPOSITION, {
            "token": "o:-t3zTt0q3n-:o"
        });
    }    
    
    getCountryExposition() {
        return this.http.post(this.URL_API_COUNTRY_EXPOSITION, {
            "token": "o:-t3zTt0q3n-:o"
        });
    }
}
